export default "__VITE_ASSET___PljK_K8__"